import { css } from "styled-components";

const regularFamily = "Helvetica Neue LT W05_55 Regular";

const mediumFamily = "Helvetica Neue LT W05_65 Medium";

const boldFamily = "Helvetica Neue LT W05_75 Bold";

const regular = css`
    font-family: "${regularFamily}", "Helvetica", Arial, sans-serif;
`;

const medium = css`
    font-family: "${mediumFamily}", "Helvetica", Arial, sans-serif;
`;

const bold = css`
    font-family: "${boldFamily}", "Helvetica", Arial, sans-serif;
`;

const fontStyles = css`
    body {
        font-family: "${mediumFamily}", "Helvetica", Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        font-size: 0.75rem;
        line-height: 0.9375rem;

        @media (min-width: 48rem) {
            font-size: 0.75rem;
            line-height: 1.03125rem;
        }
    }
`;

export {
    regular,
    medium,
    bold,
    regularFamily,
    mediumFamily,
    boldFamily,
    fontStyles
};
